import { ReactElement, ButtonHTMLAttributes, FunctionComponent, isValidElement } from 'react';
import { GenericTransactionDto } from 'types/services-api';

export interface GenericTransactionExtendedType extends GenericTransactionDto {
  replacedByCorrection?: boolean;
}

export const isReactElementWithProps = (
  child: unknown
): child is ReactElement<ButtonHTMLAttributes<unknown>, FunctionComponent> => {
  return isValidElement(child) && child.props !== undefined;
};
